import base from './base';
export const extendTheme = (
    newTheme
) => {
    return { ...base, ...newTheme };
};
